import { LoadingOutlined } from "@ant-design/icons";
import { useGetIdentity } from "@refinedev/core";
import { Flex, Row, Typography } from "antd";
import { User } from "types/props";

const TotalCredits = () => {
  const { data: user } = useGetIdentity<User>();

  return (
    <>
      {user ? (
        <>
          <Row>
            <Flex align="end" gap={4} style={{ marginTop: "12px" }}>
              <Typography.Title
                style={{
                  fontSize: "24px",
                  fontWeight: 600,
                  padding: 0,
                  margin: 0
                }}>
                {user.credits}
              </Typography.Title>
              <Typography.Text style={{ padding: 0, margin: 0, fontSize: "12px" }}>
                {"Purchased"}
              </Typography.Text>
            </Flex>
          </Row>
          <Row>
            <Flex align="end" gap={4} style={{ marginTop: "12px" }}>
              <Typography.Title
                style={{
                  fontSize: "24px",
                  fontWeight: 600,
                  padding: 0,
                  margin: 0
                }}>
                {user.freeCredits}
              </Typography.Title>
              <Typography.Text style={{ padding: 0, margin: 0, fontSize: "12px" }}>
                {"Free Credits"}
              </Typography.Text>
            </Flex>
          </Row>
        </>
      ) : (
        <LoadingOutlined />
      )}
    </>
  );
};

export default TotalCredits;
